import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ROUTER_LINKS } from '../../constants/app-strings.constants';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserRoleService } from 'src/app/core/services/user-role.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
})
export class NavbarComponent implements OnInit{
  isLoggedIn: boolean = false;
  items: MenuItem[] | undefined;

  constructor(
    private authService: AuthService,
    private router: Router,
    private userRoleService: UserRoleService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authService.getLoginStatus();
    this.authService.loginLogoutStatus$.subscribe({
      next: () => {
        this.isLoggedIn = this.authService.getLoginStatus();
        this.updateMenuItems();
      },
    });
    this.updateMenuItems();
  }

  updateMenuItems(): void {
    const role = this.userRoleService.getUserRole().trim().toLowerCase();
    const isAdmin = role === 'admin';

    this.items = [
      {
        label: "Library",
        visible: this.isLoggedIn && isAdmin,
        routerLink: ROUTER_LINKS.library
      },
      {
        label: "Test",
        visible: this.isLoggedIn,
        routerLink: ROUTER_LINKS.test
      }
    ];
  }

  logout(): void {
    this.isLoggedIn = false;
    this.authService.logout();
    this.router.navigateByUrl(ROUTER_LINKS.login);
    this.updateMenuItems();
  }
}
